import { useEffect } from "react";
import { useTheme } from "next-themes";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/lib/supabase/client";

export const ThemeSync = () => {
    const { setTheme } = useTheme();
    const { user } = useAuth();

    useEffect(() => {
        const syncTheme = async () => {
            if (!user) return;

            const { data, error } = await supabase
                .from("profiles")
                .select("theme")
                .eq("id", user.id)
                .limit(1);

            if (error) {
                console.error("Error fetching theme preference:", error);
                return;
            }

            if (data?.[0]?.theme) {
                setTheme(data[0].theme);
            }
        };

        syncTheme();
    }, [user, setTheme]);

    return null;
};
